module.exports = __webpack_public_path__ + "static/media/021-cloud.a8ed1799.svg";